<script lang="ts" setup>
import { groupAreasByZip, isAreaGroupedByZip } from '~/models/Location'
import type { LocationArea, LocationRegion } from '~/models/Location'

const emit = defineEmits<{
  (event: 'update:value', id: number | null): void
  (event: 'reset', id: number | null): void
}>()

const props = withDefaults(
  defineProps<{
    disabled?: boolean
    locations?: LocationRegion[]
    value?: number | null
    default?: number | null
  }>(),
  {
    disabled: false,
    locations: () => [],
    value: null,
    default: null,
  }
)

// flatten LocationRegion[] to LocationArea[] and group them by zip
const locations = computed(() =>
  props.locations.map((region) => region.cities.map((city) => groupAreasByZip(city.areas.map((area) => ({ ...area, city })) as LocationArea[]))).flat(2)
)
const areas = computed(() => locations.value.map((o) => (isAreaGroupedByZip(o) ? o.areas : [o])).flat())
const update = (value: number | null) => emit('update:value', value)
const reset = (value = props.default) => {
  update(value)
  emit('reset', value)
}

defineExpose({ value: props.value, update, reset })
</script>

<template>
  <div class="tw-radio-list filter--geo-id">
    <tw-ui-checkbox v-for="area in areas" :key="`TwFilterLocations_Radio_${area.id}`" variant="circle"
      :state="value === area.id" @check="update(area.id)">
      <span class="city-name">{{ area.city?.name }}</span>
      <span class="delimiter">-</span>
      <span class="zip">{{ area.zip }}</span>
      <span v-if="area.name">({{ area.name }})</span>
    </tw-ui-checkbox>
  </div>
</template>

<style lang="scss" scoped>
@import "~/assets/styles/tw-variables.scss";

.tw-radio-list {
  display: flex;
  flex-flow: column nowrap;
  gap: $tw-component--gap;
  overflow: scroll;
}

.tw-checkbox {
  flex: 1;
  align-items: center;
  cursor: pointer;
}

.tw-button {
  flex: 0;
  height: 1.75em;
  padding: $tw-component--gap;
}
</style>
